import api from './api';

const authService = {
    login: async (email, password) => {
        const params = new URLSearchParams();
        params.append('username', email);
        params.append('password', password);
        const response = await api.post('/auth/login', params, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        return response.data;
    },
    register: async (userData) => {
        const response = await api.post('/auth/register', userData);
        return response.data;
    },
    verifyOtp: async (email, otp, purpose = 'login') => {
        const response = await api.post('/auth/otp/verify', { email, otp, purpose });
        return response.data;
    },
    resendOtp: async (email, purpose = 'login') => {
        const response = await api.post('/auth/otp/send', { email, purpose });
        return response.data;
    },
    requestPasswordResetOtp: async (email) => {
        const response = await api.post('/auth/forgot-password/request-otp', { email });
        return response.data;
    },
    verifyPasswordResetOtp: async (email, otp) => {
        const response = await api.post('/auth/forgot-password/verify-otp', { email, otp });
        return response.data;
    },
    resetPassword: async (email, otp, newPassword, confirmPassword) => {
        const response = await api.post('/auth/forgot-password/reset', {
            email,
            otp,
            new_password: newPassword,
            confirm_password: confirmPassword
        });
        return response.data;
    },

    googleSignIn: async (selectedType) => {
        // TODO: Implement Google Sign-In with backend verification
        throw new Error("Google Sign-In not yet implemented in backend");
    },
    logout: async () => {
        try {
            console.log('[AUTH] Calling logout endpoint...');
            const response = await api.post('/auth/logout');
            console.log('[AUTH] Logout successful:', response.data);
            return response.data;
        } catch (e) {
            console.error('[AUTH] Logout failed:', e.response?.data || e.message);
            throw e; // Re-throw so caller knows it failed
        }
    },
    getCurrentUser: async () => {
        const response = await api.get('/auth/me');
        return response.data;
    },
    // --- HR LOGIN SUPPORT ---
    hrLogin: async (email, password) => {
        // Construct HR Base URL dynamically like in api.js or just assume relative if same domain
        // In local dev: http://localhost:8000/api/hr/api/v1/auth/login
        // In prod: /api/hr/api/v1/auth/login
        const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
        const hrApiUrl = `${baseUrl}/api/hr/api/v1`;

        const params = new URLSearchParams();
        params.append('username', email);
        params.append('password', password);

        // We use direct axios (or fetch) to avoid JobSeeker interceptors/BaseURL
        const response = await import('axios').then(m => m.default.post(`${hrApiUrl}/auth/login`, params, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }));
        return response.data;
    },
    hrVerifyOtp: async (email, otp, purpose = 'login') => {
        const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
        const hrApiUrl = `${baseUrl}/api/hr/api/v1`;

        const response = await import('axios').then(m => m.default.post(`${hrApiUrl}/otp/verify`, { email, otp, purpose }));
        return response.data;
    }
};

export default authService;
